import { formatToCurrency } from "shared/utils";
import { useAuthContext } from "providers/Auth";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowDown02Icon,
  InformationCircleIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { AdjustedApplicationRentActivity } from "shared/app/ActivityLog/types";
import moment from "moment";

export const AdjustedApplicationRentActivityLog = ({
  activityItem
}: {
  activityItem: AdjustedApplicationRentActivity;
}) => {
  const { pms } = useAuthContext();

  const getRentDetails = (
    rentAmounts: AdjustedApplicationRentActivity["details"]["new_rent_amounts"]
  ) => {
    if (!rentAmounts) return "";

    let details = "";
    if (!pms.isManageAmerica)
      details = `Rent amount (${formatToCurrency(rentAmounts.rent_amount || null)})`;
    else
      details = `Home rent (${formatToCurrency(rentAmounts.home_rent_amount || null)}) + Site rent (${formatToCurrency(rentAmounts.site_rent_amount || null)})`;

    if (rentAmounts.housing_assistance_voucher_amount)
      details += ` - Housing assistance (${formatToCurrency(rentAmounts.housing_assistance_voucher_amount)})`;

    if (rentAmounts.pet_rent_amount)
      details += ` + Pet rent (${formatToCurrency(rentAmounts.pet_rent_amount)})`;

    details += ` = Application rent (${formatToCurrency(rentAmounts.monthly_rent_amount || null)})`;

    return details;
  };

  return (
    <div className="flex gap-3 font-medium">
      <HugeiconsIcon
        icon={InformationCircleIcon}
        size={20}
        className="text-content-400"
      />
      <div className="space-y-2 flex-1">
        <p className="text-base text-content-400 space-x-2">
          <span>Application rent adjusted</span>
          <span>
            {typeof activityItem.details === "object" &&
            activityItem.activity_type ===
              "application_rent_automatically_adjusted"
              ? "automatically"
              : `by ${activityItem.author?.name || "--"}`}
          </span>
        </p>
        {activityItem.details.old_rent_amounts &&
        activityItem.details.new_rent_amounts ? (
          <div>
            <p className="text-sm text-content-300">
              <span className="text-content-1000">Before: </span>
              <span>
                {getRentDetails(activityItem.details.old_rent_amounts)}
              </span>
            </p>
            <HugeiconsIcon
              icon={ArrowDown02Icon}
              size={20}
              className="text-content-1000 my-2"
            />
            <p className="text-sm text-content-300">
              <span className="text-content-1000">After: </span>
              <span>
                {getRentDetails(activityItem.details.new_rent_amounts)}
              </span>
            </p>
          </div>
        ) : null}
      </div>
      <div className="text-content-300">
        {moment(activityItem.created_at).format("MMM DD, YYYY [at] h:mm A")}
      </div>
    </div>
  );
};
